import React, { useEffect, useState } from "react";
import Tabla from "./Tabla/index";
import canales_icon from "../../../assets/vw/svg/canales.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../components/Menu"
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";


function Canales(props) {
  const [dataCanales, setDataCanales] = useState([]);
  const [canal, setCanal] = useState([]);
  const [canalesInactivas, setCanalesInactivas] = useState([]);
  const [inactivasFilter, setInactivasFilter] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [option, setOption] = useState("canales");
  const [dataOriginal, setDataOriginal] = useState([])
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false
  });

  async function getCanales() {

    try {
      setCargando(true);
      setModal({
        active: false,
        message: '',
        success: false
      });
      const response = await fetch(
        process.env.REACT_APP_URL_DTO_BACK + "canales",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error("Error en el feching de CANALES" + data.mensaje);
      }

      setDataOriginal(data.mensaje)
      const activas = data.mensaje.filter((canal) => {
        return canal.activo === 1;
      });
      setDataCanales(activas);
      setCargando(false);
    } catch (error) {
      setCargando(false);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    }

  }

  //Obtiene lo tecleado en el buscador
  const handleChange = (e) => {
    setCanal([])
    setInactivasFilter([])
    if (option === "archivo") {
      filtrarInactivas(e.target.value)
    } else {
      filtrar(e.target.value);
    }

  };

  //almacena los datos que hacen MATCH de lo tecleado en el buscador
  const filtrar = (terminoBusqueda) => {
    const resultado = dataCanales.filter((element) => {
      if (
        element.nombre.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setCanal(resultado); //Obtenemos los match
  };

  const filtrarInactivas = (terminoBusqueda) => {
    const resultado = canalesInactivas.filter((element) => {
      if (
        element.nombre.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setInactivasFilter(resultado); //Obtenemos los match
  };

  const changeOption = (option) => {
    setCanal([])
    setInactivasFilter([])
    setOption(option);
    if (option === "archivo") {
      getCanalesInactivas(dataOriginal);
    }
  };

  const getCanalesInactivas = (data) => {
    const inactivas = data.filter((canal) => {
      return canal.activo === 0;
    });
    setCanalesInactivas(inactivas);
  };


  useEffect(() => {
    getCanales();
  }, []);

  return (
    <>
      <Menu />
      <Modal modalInfo={modal} setMostrarModal={setModal} />
      {
        cargando && <Loading />
      }
      <div className={`navegacion`}>
        {dataOriginal.length > 0 ? (
          <>
            <div className=" posicionMenu">
              <ul className="d-flex flex-row px-0 my-0">
                <li
                  className="opcion-ruta"
                  onClick={() => changeOption("canales")}
                >
                  <div
                    className={`nav-link nav-link-title active ps-0 ${option === "canales" ? " active border_menu" : ""
                      }`}
                  >
                    <img
                      src={canales_icon}
                      alt="canales"
                      className="icono-menu me-3"
                    />
                    Canales
                  </div>
                </li>
                <li className="opcion-ruta" onClick={() => changeOption("archivo")}>
                  <div
                    className={`nav-link active ps-0  ${option === "archivo" ? " active border_menu" : ""
                      }`}
                  >
                    <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                    Archivo
                  </div>
                </li>
              </ul>
            </div>
            <div className="row border_vw pt-4 ms-0 mx-0">
              <div className="col-12 p-0 contenedor-table">
                {option === "archivo" ? (
                  <TablaArchivo
                    servicio={props.servicio} canales={inactivasFilter && inactivasFilter.length > 0 ? inactivasFilter : canalesInactivas} handleChange={handleChange}
                  />
                ) : (
                  <Tabla
                    servicio={props.servicio} canales={canal && canal.length > 0 ? canal : dataCanales} handleChange={handleChange}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            {
              !cargando && <NoInfoScreen />
            }
          </>
        )
        }
      </div>
    </>
  );
}

export default Canales;
